import React, { useEffect, useState } from "react";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  query,
  serverTimestamp,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../firebase";
import useAuth from "../Auth/useAuth";

const AdministratorStudentVerification = () => {
  const { user } = useAuth();
  const [userTypeVerification, setUserTypeVerification] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedId, setSelectedId] = useState("");

  useEffect(() => {
    const q = query(
      collection(db, "studentUserTypeVerify"),
      where("status", "==", "Not Verified")
    );
    onSnapshot(q, (querySnapshot) => {
      let userArray = [];
      querySnapshot.forEach((doc) => {
        userArray.push({ id: doc.id, ...doc.data() });
      });
      setUserTypeVerification(userArray);
    });
  }, []);

  console.log(selectedId);

  const handleOnSendRequest = async () => {
    const requestOptions = await fetch(
      "https://asia-south1-my-test-bed-d0d2c.cloudfunctions.net/addUserType",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          data: {
            email: selectedEmail,
            userType: "student",
            designation: "student",
            status: "assigned",
          },
        }),
      }
    )?.then(() => {
      updateDoc(doc(db, "studentUserTypeVerify", selectedId), {
        email: selectedEmail,
        userType: "student",
        designation: "student",
        status: "assigned",
        date: serverTimestamp(),
      })
        ?.then(() => {
          // window.location.reload(true);
          console.log("doc updated");
        })
        ?.catch((error) => {
          console.log("Send Request Error" +error.message);
        });
    });
    console.log("hello world");
    // const json = requestOptions.json();
    if (!requestOptions.ok) {
      console.log("Error");
      // console.log(json.error);
    } else {
      console.log("No");
      console.log(requestOptions.status);
    }
  };

  const deleteField = async (sid) => {
    await deleteDoc(doc(db, "studentUserTypeVerify", sid));
    console.log("Deleted ===>" + sid);
  };

  // console.log(selectedEmail);
  return (
    <div className="p-10">
      <div>
        <table className="w-full  text-center">
          <thead className="border-b  ">
            <tr className="bg-gray-100">
              <th className="py-3 "> Sl No.</th>
              <th className="py-3 ">Student Code</th>
              <th className="py-3 ">Email</th>
              <th className="py-3 ">Select</th>
              <th className="py-3 ">Assign</th>
              <th className="py-3 ">Delete</th>
            </tr>
          </thead>
          <tbody>
            {userTypeVerification?.map((item, index) => (
              <tr className="border-b" key={index}>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  {++index}
                </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  {item.studentIdNumber}
                </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  {item.email}
                </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  <button
                    className="text-white bg-blue-600 py-1 px-1 rounded-md "
                    onClick={() => {
                      setSelectedEmail(item.email);
                      setMenuOpen(true);
                      setSelectedId(item.id);
                    }}
                  >
                    Select
                  </button>
                </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  {item.status}
                </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  <button
                    className="text-white bg-red-600 py-1 px-1 rounded-md "
                    onClick={() => deleteField(item.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {menuOpen && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity">
          <div className="fixed z-0 grid grid-rows-3 justify-center items-center inset-0 overflow-y-auto p-20">
            <div className=" bg-white rounded-md  row-span-2">
              <div className="p-5">
                <div className="grid grid-cols-7 justify-evenly">
                  <h2 className="font-bold text-md text-right col-span-3">
                    Student Code
                  </h2>
                  <h2 className="font-bold text-md col-span-1">:</h2>
                  <h2 className="font-bold text-md text-left col-span-3">
                    {userTypeVerification[0]?.studentIdNumber}
                  </h2>
                </div>
                <div className="grid grid-cols-7 justify-evenly">
                  <h2 className="font-bold text-md text-right col-span-3">
                    Academic Session
                  </h2>
                  <h2 className="font-bold text-md col-span-1">:</h2>
                  <h2 className="font-bold text-md text-left col-span-3">
                    {userTypeVerification[0]?.email}
                  </h2>
                </div>
              </div>
              <div className="flex p-5 justify-between">
                <div className="ml-10">
                  <button
                    className="bg-green-400 p-1 text-2xl text-white font-semibold rounded-lg"
                    onClick={handleOnSendRequest}
                  >
                    Assign
                  </button>
                </div>
                <div className="mr-10">
                  <button
                    onClick={() => {
                      setMenuOpen(false);
                      setSelectedEmail("");
                    }}
                    className="bg-red-400 p-1 text-2xl text-white font-semibold rounded-lg"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div></div>
    </div>
  );
};

export default AdministratorStudentVerification;
